import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { classNames } from 'primereact/utils';
import React, {useContext, useRef, useState} from "react";
import {UserService} from "../services/UserService";
import { useSearchParams} from 'react-router';
import {AuthContext} from "../App";
import {Messages} from "primereact/messages";

export default function ResetPassword() {
    //const { code, error, status } = useLoaderData();
    const userservice = new UserService();
    const auth = useContext(AuthContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const [showMessage, setShowMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({});
    const errorMessageRef = useRef(null);

    // Read parameters
    const code = searchParams.get('code') ?? '';     // string | null
    //const state =  searchParams.get('username');

    const formik = useFormik({
        initialValues: {
            password: '',
            passwordrep: '',
        },
        validate: (data) => {
            let errors = {};

            if (!data.password) {
                errors.password = 'Password is required.';
            }
            else if (data.password.length < 8) {
                errors.password = 'Password must be at least 8 characters long';
            }

            if (data.passwordrep !== data.password) {
                errors.passwordrep = 'Passwords are not identical';
            }

            return errors;
        },
        onSubmit: (data) => {
            setFormData(data);
            //delete data.passwordrep;
            let send_data = {
                reset_token: code,
                password: data.password,
            }
            userservice.resetPassword(send_data).then((res) => {
                if(res.status === 200) {
                    res.json().then(data => {
                        setShowMessage(true);
                        errorMessageRef.current.show({
                            severity: 'success',
                            summary: 'Password reset successfully.',
                            sticky: true
                        });
                        formik.resetForm();
                    })
                }
                else
                {
                    res.json().then(error => {
                        errorMessageRef.current.show({severity: 'error', summary: 'Could not reset password.', detail: error?.detail, sticky: true});
                    })
                }
            })
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const dialogFooter = <div className="flex justify-content-center"><Button label="OK" className="p-button-text" autoFocus onClick={() => setShowMessage(false)} /></div>;
    const passwordHeader = <h6>Pick a new password</h6>;
    const passwordFooter = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Requirements</p>
            <ul className="pl-2 ml-2 mt-0" style={{ lineHeight: '1.5' }}>
                <li>Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );

    return (
        <div>
            <Dialog visible={showMessage} onHide={() => setShowMessage(false)}
                    position="top"  showHeader={false} breakpoints={{ '960px': '80vw' }} style={{ width: '30vw' }}
                    closable={true}  closeOnEscape={true}
                    footer={dialogFooter}
            >
                <div className="flex align-items-center flex-column pt-6 px-3">
                    <h5>Password update successful!</h5>
                    <p style={{ lineHeight: 1.5, textIndent: '1rem' }}>
                        You can now go <a href="https://playlist.laramon.ch">to the playlist generator</a> and login again. Thank you!
                    </p>
                </div>
            </Dialog>

            <div className="flex justify-content-center">
                <div className="card">
                    <form onSubmit={formik.handleSubmit} className="p-fluid">
                        <div className="field">
                            <span className="p-float-label">
                                <Password id="password" name="password" value={formik.values.password} onChange={formik.handleChange} toggleMask
                                          className={classNames({ 'p-invalid': isFormFieldValid('password') })} header={passwordHeader} footer={passwordFooter} />
                                <label htmlFor="password" className={classNames({ 'p-error': isFormFieldValid('password') })}>New Password</label>
                            </span>
                            {getFormErrorMessage('password')}
                        </div>
                        <div className="field">
                            <span className="p-float-label">
                                <Password id="passwordrep" name="passwordrep" value={formik.values.passwordrep} onChange={formik.handleChange} toggleMask feedback={false}
                                          className={classNames({ 'p-invalid': isFormFieldValid('passwordrep') })}/>
                                <label htmlFor="passwordrep">New Password (repeat)</label>
                            </span>
                            {getFormErrorMessage('passwordrep')}
                        </div>

                        <Button type="submit" label="Change Password" className="mt-2"/>
                    </form>
                </div>
            </div>
            <Messages ref={errorMessageRef} />
        </div>
    );
}